import React, { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import logo from "../../assets/img/logo/logo.png";

const Header = () => {
  const [showAuthModal, setShowAuthModal] = useState(false);

  const openModal = (e) => {
    e.preventDefault();
    setShowAuthModal(true);
  };

  const closeModal = () => {
    setShowAuthModal(false);
  };

  return (
    <div>
      <style jsx>{`
        /* Your existing styles */
        .nav-right-btn .theme-btn:hover,
        .green-btn:hover {
          background-color: #fede33 !important;
          border-color: #fede33 !important;
          color: #000000 !important;
        }
        .green-btn {
          background: #098535 !important;
          border: none !important;
          padding: 12px 30px;
          border-radius: 25px;
          display: inline-flex;
          align-items: center;
          color: white !important;
          text-decoration: none;
          transition: all 0.3s ease;
          font-weight: 600;
        }
        .green-btn:hover {
          background: #fede33 !important;
          color: #000 !important;
        }
        .green-btn:hover i {
          color: #000 !important;
        }

        /* Beautiful Auth Modal */
        .auth-modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.7);
          backdrop-filter: blur(8px);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
          animation: fadeIn 0.3s ease;
        }
        .auth-modal {
          background: white;
          border-radius: 24px;
          width: 90%;
          max-width: 480px;
          padding: 50px 40px;
          text-align: center;
          box-shadow: 0 25px 70px rgba(0, 0, 0, 0.3);
          position: relative;
          animation: slideUp 0.4s ease;
        }
        .modal-close {
          position: absolute;
          top: 18px;
          right: 22px;
          background: none;
          border: none;
          font-size: 28px;
          color: #aaa;
          cursor: pointer;
          transition: color 0.3s;
        }
        .modal-close:hover {
          color: #000;
        }
        .modal-icon {
          width: 90px;
          height: 90px;
          background: linear-gradient(135deg, #098535, #0a6d2b);
          color: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 24px;
          font-size: 42px;
          box-shadow: 0 10px 30px rgba(9, 133, 53, 0.4);
        }
        .modal-title {
          font-size: 28px;
          font-weight: 900;
          color: #000;
          margin-bottom: 16px;
        }
        .modal-text {
          font-size: 18px;
          color: #555;
          line-height: 1.6;
          margin-bottom: 32px;
        }
        .modal-buttons {
          display: flex;
          flex-direction: column;
          gap: 16px;
        }
        .modal-btn {
          padding: 16px 32px;
          border-radius: 16px;
          font-size: 18px;
          font-weight: 700;
          text-decoration: none;
          display: inline-block;
          transition: all 0.3s ease;
          width: 100%;
          max-width: 320px;
          margin: 0 auto;
        }
        .login-btn {
          background: #098535;
          color: white;
        }
        .login-btn:hover {
          background: #000000 !important; /* Black background on hover */
          color: #fede33 !important; /* Yellow text on hover */
          transform: translateY(-3px);
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.4);
        }
        .signup-btn {
          background: #fede33;
          color: #000;
          border: 2px solid #fede33;
        }
        .signup-btn:hover {
          background: #000 !important;
          color: #fede33 !important;
          border-color: #000;
          transform: translateY(-3px);
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @media (max-width: 576px) {
          .auth-modal {
            padding: 40px 25px;
            margin: 20px;
          }
          .modal-title {
            font-size: 24px;
          }
          .modal-text {
            font-size: 17px;
          }
        }
      `}</style>

      {/* Your existing header */}
      <header className="header">
        {/* ... your top header and nav code unchanged ... */}

        <div className="main-navigation">
          <nav className="navbar navbar-expand-lg">
            <div className="container position-relative">
              <Link className="navbar-brand" to="/">
                <img src={logo} alt="logo" />
              </Link>

              <div className="mobile-menu-right">
                <button
                  className="navbar-toggler"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#main_nav"
                >
                  <span className="navbar-toggler-mobile-icon">
                    <i className="far fa-bars"></i>
                  </span>
                </button>
              </div>

              <div className="collapse navbar-collapse" id="main_nav">
                <ul className="navbar-nav">
                  <li className="nav-item">
                    <NavLink
                      to="/"
                      end
                      className={({ isActive }) =>
                        `nav-link ${isActive ? "active" : ""}`
                      }
                    >
                      Home
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink
                      to="/about"
                      className={({ isActive }) =>
                        `nav-link ${isActive ? "active" : ""}`
                      }
                    >
                      About
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink
                      to="/rider"
                      className={({ isActive }) =>
                        `nav-link ${isActive ? "active" : ""}`
                      }
                    >
                      Rider
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink
                      to="/driver"
                      className={({ isActive }) =>
                        `nav-link ${isActive ? "active" : ""}`
                      }
                    >
                      Driver
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink
                      to="/contact"
                      className={({ isActive }) =>
                        `nav-link ${isActive ? "active" : ""}`
                      }
                    >
                      Contact
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink
                      to="/privacy-policy"
                      className={({ isActive }) =>
                        `nav-link ${isActive ? "active" : ""}`
                      }
                    >
                      Privacy Policy
                    </NavLink>
                  </li>
                </ul>

                <div className="nav-right">
                  <div className="nav-right-btn mt-2">
                    <a href="#" onClick={openModal} className="green-btn">
                      <span
                        className="fas fa-taxi"
                        style={{ marginRight: "10px" }}
                      ></span>
                      Book A Ride
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </nav>
        </div>
      </header>

      {/* Beautiful Auth Modal */}
      {showAuthModal && (
        <div className="auth-modal-overlay" onClick={closeModal}>
          <div className="auth-modal" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>
              ×
            </button>

            <div className="modal-icon">
              <i className="fas fa-taxi"></i>
            </div>

            <h2 className="modal-title">Ready to Ride?</h2>
            <p className="modal-text">
              Sign up or log in to book your ride instantly with CabandGo
            </p>

            <div className="modal-buttons">
              <NavLink
                to="/login"
                className="modal-btn login-btn"
                onClick={closeModal}
              >
                Log In
              </NavLink>
              <NavLink
                to="/register"
                className="modal-btn signup-btn"
                onClick={closeModal}
              >
                Sign Up – It's Free!
              </NavLink>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Header;
